webpackJsonp([1],{

/***/ 132:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MEMwNzg0NjA3OEZGMTFFN0ExODhBNzhCNjIxMDBBNjUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MEMwNzg0NjE3OEZGMTFFN0ExODhBNzhCNjIxMDBBNjUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowQzA3ODQ1RTc4RkYxMUU3QTE4OEE3OEI2MjEwMEE2NSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowQzA3ODQ1Rjc4RkYxMUU3QTE4OEE3OEI2MjEwMEE2NSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PoMlVz4AAAIvSURBVHjatJZNSFRRFMff+LFwlMAYMBGl/MrKTYYRYrSIBINRKgSdTAYxhCDXrsZ04aI27RI0sQK/WojIyOAqELN27TIrJYi0RaghutDJfkfOg9fjjc6bZi78uLx37zv/c8+795zryTh7wziinYPbIJMK4RRsww94C2GI7C3N/bF/mFlRd5HO54khUA6PoVGff8FX+Ak5cBrO6Ngn6EFkwibwju58hoPxdhiAdHgBz2EB7F6KwD3ognEMNtB3IrSt41ngTbN9FFKDn+ESBGHewbi0VeiDUhDvAzCLULZ1klWgBXrhDdTAByOOhseb0Kyrvgpj1nEzREUwpJ7fgi3DfXsIJeBnFfftK3ikMZNlbiZgXFayT9cEK9APHnkvu6iA/htM6QQ3zQt5tnd34InuOJ+EyK875plL4+LhMhTEGBfhPRGo15jPuxQ4gGGoinFAc+UsiUAxfBS1BEIfIvZHTpCfnA9rRopamiWeKRNY01WkTGBFf0pmMgxyyHIgDEFTIAIn4FqSnK6Em5rHDgVmIAoPkiRwWftJU+A7vNIcdOU/w+PTtLMBL+25aBdG4WSCxmUnPtUD1m3WBVNAclGHFpFptyIYl1QzAnel+MCgUz0Y1XpQC4tQHafxQk2UbfAaWvH+wEnADJW5kvcqet1SN6ytTBPkF02Y4nkA49F/MmKMol+hRd+vz7+1RK5rii62ZNFVjfmkY8o95tpyweHasqPXlgW9toSdri1m+yvAACyDjIJupfEkAAAAAElFTkSuQmCC"

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(143)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_News__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_News___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_News__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    News: __WEBPACK_IMPORTED_MODULE_0__components_News___default.a
  },
  methods: {
    isPc: function isPc() {
      return screen.width > 800 ? true : false;
    }
  }

});

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileNewsItem_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileNewsItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MobileNewsItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_util__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_livedata_js__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: { MobileNewsItem: __WEBPACK_IMPORTED_MODULE_0__MobileNewsItem_vue___default.a },
    data: function data() {
        return {
            newsData: [],
            liveData: [],
            liveLinks: [{
                img: 'https://static-image.xfz.cn/1573722550136/云现场-fintech.partner',
                link: 'http://www.yun-live.com/meeting/587'
            }, {
                img: 'https://static-image.xfz.cn/1573725094527/微吼-fintech.partner',
                link: 'https://zhike.vhall.com/webinar/subscribe/97535488'
            }, {
                img: 'https://static-image.xfz.cn/1573722615936/盟主直播-fintech.partner',
                link: 'http://z-mz.cn/MTvw'
            }, {
                img: 'https://static-image.xfz.cn/1573722333455/风岐茶社-fintech.partner',
                link: 'http://www.phoenixtea.org/live/1468'
            }],

            investorUpData: [{
                img: "http://static-image.xfz.cn/1503036169_345.jpg-course.list.small",
                url: "http://www.xfz.cn/course/131.html",
                title: "消费新方圆——下一代的成功范式",
                name: "张鑫钊",
                position: "启承资本董事总经理"
            }, {
                img: "http://static-image.xfz.cn/1503036079_897.jpg-course.list.small",
                url: "http://www.xfz.cn/course/134.html",
                title: "创业VS投资：反观消费升级的新价值",
                name: "周航",
                position: "顺为资本投资合伙人"
            }, {
                img: "http://static-image.xfz.cn/1503382942_469.jpg-course.list.small",
                url: "http://www.xfz.cn/course/140.html",
                title: "互联网投资趋势下的消费升级",
                name: "郎春晖",
                position: "创新工场合伙人"
            }, {
                img: "http://static-image.xfz.cn/1503397089_562.jpg-course.list.small",
                url: "http://www.xfz.cn/course/152.html",
                title: "消费升级创业的机会与投资",
                name: "投资大咖论",
                position: ""
            }],

            useUpData: [{
                img: "http://static-image.xfz.cn/1503036256_116.jpg-course.list.small",
                url: "http://www.xfz.cn/course/129.html",
                title: "信用生态驱动的消费转型趋势",
                name: "李丛杉",
                position: "蚂蚁金服芝麻信用副总经理"
            }, {
                img: "http://static-image.xfz.cn/1503036141_896.jpg-course.list.small",
                url: "http://www.xfz.cn/course/132.html",
                title: "莫善于乐——从“维纳斯计划”到迷你KTV",
                name: "马杰",
                position: "雷石CEO 、WOW屋创始人"
            }, {
                img: "http://static-image.xfz.cn/1503036105_512.jpg-course.list.small",
                url: "http://www.xfz.cn/course/133.html",
                title: "新商业机会下的品类升级",
                name: "林依轮",
                position: "饭爷品牌创始人"
            }, {
                img: "http://static-image.xfz.cn/1503036037_651.jpg-course.list.small",
                url: "http://www.xfz.cn/course/135.html",
                title: "生鲜新零售的终极布局",
                name: "徐正",
                position: "每日优鲜创始人兼CEO"
            }, {
                img: "http://static-image.xfz.cn/1503036005_238.jpg-course.list.small",
                url: "http://www.xfz.cn/course/136.html",
                title: "消费升级背后的5个真相",
                name: "朱月怡",
                position: "花点时间创始人兼CEO"
            }, {
                img: "http://static-image.xfz.cn/1503035974_824.jpg-course.list.small",
                url: "http://www.xfz.cn/course/137.html",
                title: "共享充电行业如何打赢持久战",
                name: "唐永波",
                position: "小电科技创始人兼CEO"
            }, {
                img: "http://static-image.xfz.cn/1503035919_824.jpg-course.list.small",
                url: "http://www.xfz.cn/course/138.html",
                title: "一个新消费品的全渠道成长之路",
                name: "刘丹尼",
                position: "乐纯CEO"
            }, {
                img: "http://static-image.xfz.cn/1503035847_516.jpg-course.list.small",
                url: "http://www.xfz.cn/course/141.html",
                title: "生活方式空间的场景打造",
                name: "但捷",
                position: "言几又董事长兼CEO"
            }, {
                img: "http://static-image.xfz.cn/1503035815_532.jpg-course.list.small",
                url: "http://www.xfz.cn/course/142.html",
                title: "消费升级下的医美市场",
                name: "金星",
                position: "新氧创始人兼CEO"
            }, {
                img: "http://static-image.xfz.cn/1503035794_864.jpg-course.list.small",
                url: "http://www.xfz.cn/course/143.html",
                title: "从需求迭代看中国房屋分享",
                name: "王连涛",
                position: "小猪联合创始人兼COO"
            }, {
                img: "http://static-image.xfz.cn/1503282295_909.jpg-course.list.small",
                url: "http://www.xfz.cn/course/144.html",
                title: "体育运动产业的新零售与共享入口",
                name: "韩伟",
                position: "乐刻运动创始人兼CEO"
            }, {
                img: "http://static-image.xfz.cn/1503035698_83.jpg-course.list.small",
                url: "http://www.xfz.cn/course/145.html",
                title: "洞察新未来——音乐教育行业的一元复始",
                name: "张桐",
                position: "Finger创始人兼CEO"
            }]

        };
    },

    methods: {
        getNewsListFake: function getNewsListFake() {
            this.newsData = this.newDataFake.data;
        },
        getNewsList: function getNewsList() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_1__assets_js_util__["a" /* default */].resource({
                url: '/api/website/articles/?tag=2019小饭桌全球青年创业者大会&n=1000&p=1',
                method: 'get',
                success: function success(res) {
                    if (res.code == 200) {
                        self.newsData = res.data;
                    }
                }
            });
        },
        refreshContent: function refreshContent() {
            this.newsData = [];
            this.getNewsList();
        }
    },
    mounted: function mounted() {
        this.getNewsList();

        this.liveData = __WEBPACK_IMPORTED_MODULE_2__assets_js_livedata_js__["a" /* default */];
        __WEBPACK_IMPORTED_MODULE_1__assets_js_util__["a" /* default */].getWx();
    }
});

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('en', {
    relativeTime: {
        future: "%s后",
        past: "%s前",
        s: "几秒",
        m: "1 分钟",
        mm: "%d 分钟",
        h: "1 小时",
        hh: "%d 小时",
        d: "1 天",
        dd: "%d 天",
        M: "1 个月",
        MM: "%d 月",
        y: "1 年",
        yy: "%d 年"
    }
});

/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['news'],
    methods: {
        timeAgo: function timeAgo(time) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).fromNow();
        }
    }
});

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PcNews_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PcNews_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PcNews_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MobileNews_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MobileNews_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MobileNews_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: { PcNews: __WEBPACK_IMPORTED_MODULE_0__PcNews_vue___default.a, MobileNews: __WEBPACK_IMPORTED_MODULE_1__MobileNews_vue___default.a },
    methods: {
        isPc: function isPc() {
            return screen.width > 800 ? true : false;
        }
    }
});

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PcNewsItem_vue__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PcNewsItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PcNewsItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_util__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_livedata_js__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: { PcNewsItem: __WEBPACK_IMPORTED_MODULE_0__PcNewsItem_vue___default.a },
    data: function data() {
        return {
            showNav: true,
            newsData: [],
            liveData: [],
            liveLinks: [{
                img: 'https://static-image.xfz.cn/1573722550136/云现场-fintech.partner',
                link: 'http://www.yun-live.com/meeting/587'
            }, {
                img: 'https://static-image.xfz.cn/1573725094527/微吼-fintech.partner',
                link: 'https://zhike.vhall.com/webinar/subscribe/97535488'
            }, {
                img: 'https://static-image.xfz.cn/1573722615936/盟主直播-fintech.partner',
                link: 'http://z-mz.cn/MTvw'
            }, {
                img: 'https://static-image.xfz.cn/1573722333455/风岐茶社-fintech.partner',
                link: 'http://www.phoenixtea.org/live/1468'
            }],

            investorUpData: [{
                img: "http://static-image.xfz.cn/1503036169_345.jpg-course.list.small",
                url: "http://www.xfz.cn/course/131.html",
                title: "消费新方圆——下一代的成功范式",
                name: "张鑫钊",
                position: "启承资本董事总经理"
            }, {
                img: "http://static-image.xfz.cn/1503036079_897.jpg-course.list.small",
                url: "http://www.xfz.cn/course/134.html",
                title: "创业VS投资：反观消费升级的新价值",
                name: "周航",
                position: "顺为资本投资合伙人"
            }, {
                img: "http://static-image.xfz.cn/1503382942_469.jpg-course.list.small",
                url: "http://www.xfz.cn/course/140.html",
                title: "互联网投资趋势下的消费升级",
                name: "郎春晖",
                position: "创新工场合伙人"
            }, {
                img: "http://static-image.xfz.cn/1503397089_562.jpg-course.list.small",
                url: "http://www.xfz.cn/course/152.html",
                title: "消费升级创业的机会与投资",
                name: "投资大咖论",
                position: ""
            }],

            useUpData: [{
                img: "http://static-image.xfz.cn/1503036256_116.jpg-course.list.small",
                url: "http://www.xfz.cn/course/129.html",
                title: "信用生态驱动的消费转型趋势",
                name: "李丛杉",
                position: "蚂蚁金服芝麻信用副总经理"
            }, {
                img: "http://static-image.xfz.cn/1503036141_896.jpg-course.list.small",
                url: "http://www.xfz.cn/course/132.html",
                title: "莫善于乐——从“维纳斯计划”到迷你KTV",
                name: "马杰",
                position: "雷石CEO 、WOW屋创始人"
            }, {
                img: "http://static-image.xfz.cn/1503036105_512.jpg-course.list.small",
                url: "http://www.xfz.cn/course/133.html",
                title: "新商业机会下的品类升级",
                name: "林依轮",
                position: "饭爷品牌创始人"
            }, {
                img: "http://static-image.xfz.cn/1503036037_651.jpg-course.list.small",
                url: "http://www.xfz.cn/course/135.html",
                title: "生鲜新零售的终极布局",
                name: "徐正",
                position: "每日优鲜创始人兼CEO"
            }, {
                img: "http://static-image.xfz.cn/1503036005_238.jpg-course.list.small",
                url: "http://www.xfz.cn/course/136.html",
                title: "消费升级背后的5个真相",
                name: "朱月怡",
                position: "花点时间创始人兼CEO"
            }, {
                img: "http://static-image.xfz.cn/1503035974_824.jpg-course.list.small",
                url: "http://www.xfz.cn/course/137.html",
                title: "共享充电行业如何打赢持久战",
                name: "唐永波",
                position: "小电科技创始人兼CEO"
            }, {
                img: "http://static-image.xfz.cn/1503035919_824.jpg-course.list.small",
                url: "http://www.xfz.cn/course/138.html",
                title: "一个新消费品的全渠道成长之路",
                name: "刘丹尼",
                position: "乐纯CEO"
            }, {
                img: "http://static-image.xfz.cn/1503035847_516.jpg-course.list.small",
                url: "http://www.xfz.cn/course/141.html",
                title: "生活方式空间的场景打造",
                name: "但捷",
                position: "言几又董事长兼CEO"
            }, {
                img: "http://static-image.xfz.cn/1503035815_532.jpg-course.list.small",
                url: "http://www.xfz.cn/course/142.html",
                title: "消费升级下的医美市场",
                name: "金星",
                position: "新氧创始人兼CEO"
            }, {
                img: "http://static-image.xfz.cn/1503035794_864.jpg-course.list.small",
                url: "http://www.xfz.cn/course/143.html",
                title: "从需求迭代看中国房屋分享",
                name: "王连涛",
                position: "小猪联合创始人兼COO"
            }, {
                img: "http://static-image.xfz.cn/1503282295_909.jpg-course.list.small",
                url: "http://www.xfz.cn/course/144.html",
                title: "体育运动产业的新零售与共享入口",
                name: "韩伟",
                position: "乐刻运动创始人兼CEO"
            }, {
                img: "http://static-image.xfz.cn/1503035698_83.jpg-course.list.small",
                url: "http://www.xfz.cn/course/145.html",
                title: "洞察新未来——音乐教育行业的一元复始",
                name: "张桐",
                position: "Finger创始人兼CEO"
            }]
        };
    },

    methods: {
        addListenScroll: function addListenScroll() {
            var self = this;
            window.onscroll = function (e) {
                var h_scrolled = document.body.scrollTop;

                if (h_scrolled > 500) {
                    self.showNav = false;
                } else {
                    self.showNav = true;
                }
            };
        },
        getNewsListFake: function getNewsListFake() {
            this.newsData = this.newDataFake.data;
        },
        getNewsList: function getNewsList() {

            var self = this;
            __WEBPACK_IMPORTED_MODULE_1__assets_js_util__["a" /* default */].resource({
                url: '/api/website/articles/?tag=2019小饭桌全球青年创业者大会&n=1000&p=1',
                method: 'get',
                success: function success(res) {
                    if (res.code == 200) {
                        self.newsData = res.data;
                    }
                }
            });
        },
        refreshContent: function refreshContent() {
            this.newsData = [];
            this.getNewsList();
        }
    },
    mounted: function mounted() {
        this.liveData = __WEBPACK_IMPORTED_MODULE_2__assets_js_livedata_js__["a" /* default */];
        this.addListenScroll();
        this.getNewsList();

        __WEBPACK_IMPORTED_MODULE_1__assets_js_util__["a" /* default */].getWx();
    }
});

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('en', {
    relativeTime: {
        future: "%s后",
        past: "%s前",
        s: "几秒",
        m: "1 分钟",
        mm: "%d 分钟",
        h: "1 小时",
        hh: "%d 小时",
        d: "1 天",
        dd: "%d 天",
        M: "1 个月",
        MM: "%d 月",
        y: "1 年",
        yy: "%d 年"
    }
});

/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['news'],
    methods: {
        timeAgo: function timeAgo(time) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).fromNow();
        }
    }
});

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(134);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 5,
	"./af.js": 5,
	"./ar": 12,
	"./ar-dz": 6,
	"./ar-dz.js": 6,
	"./ar-kw": 7,
	"./ar-kw.js": 7,
	"./ar-ly": 8,
	"./ar-ly.js": 8,
	"./ar-ma": 9,
	"./ar-ma.js": 9,
	"./ar-sa": 10,
	"./ar-sa.js": 10,
	"./ar-tn": 11,
	"./ar-tn.js": 11,
	"./ar.js": 12,
	"./az": 13,
	"./az.js": 13,
	"./be": 14,
	"./be.js": 14,
	"./bg": 15,
	"./bg.js": 15,
	"./bm": 16,
	"./bm.js": 16,
	"./bn": 17,
	"./bn.js": 17,
	"./bo": 18,
	"./bo.js": 18,
	"./br": 19,
	"./br.js": 19,
	"./bs": 20,
	"./bs.js": 20,
	"./ca": 21,
	"./ca.js": 21,
	"./cs": 22,
	"./cs.js": 22,
	"./cv": 23,
	"./cv.js": 23,
	"./cy": 24,
	"./cy.js": 24,
	"./da": 25,
	"./da.js": 25,
	"./de": 28,
	"./de-at": 26,
	"./de-at.js": 26,
	"./de-ch": 27,
	"./de-ch.js": 27,
	"./de.js": 28,
	"./dv": 29,
	"./dv.js": 29,
	"./el": 30,
	"./el.js": 30,
	"./en-SG": 31,
	"./en-SG.js": 31,
	"./en-au": 32,
	"./en-au.js": 32,
	"./en-ca": 33,
	"./en-ca.js": 33,
	"./en-gb": 34,
	"./en-gb.js": 34,
	"./en-ie": 35,
	"./en-ie.js": 35,
	"./en-il": 36,
	"./en-il.js": 36,
	"./en-nz": 37,
	"./en-nz.js": 37,
	"./eo": 38,
	"./eo.js": 38,
	"./es": 41,
	"./es-do": 39,
	"./es-do.js": 39,
	"./es-us": 40,
	"./es-us.js": 40,
	"./es.js": 41,
	"./et": 42,
	"./et.js": 42,
	"./eu": 43,
	"./eu.js": 43,
	"./fa": 44,
	"./fa.js": 44,
	"./fi": 45,
	"./fi.js": 45,
	"./fo": 46,
	"./fo.js": 46,
	"./fr": 49,
	"./fr-ca": 47,
	"./fr-ca.js": 47,
	"./fr-ch": 48,
	"./fr-ch.js": 48,
	"./fr.js": 49,
	"./fy": 50,
	"./fy.js": 50,
	"./ga": 51,
	"./ga.js": 51,
	"./gd": 52,
	"./gd.js": 52,
	"./gl": 53,
	"./gl.js": 53,
	"./gom-latn": 54,
	"./gom-latn.js": 54,
	"./gu": 55,
	"./gu.js": 55,
	"./he": 56,
	"./he.js": 56,
	"./hi": 57,
	"./hi.js": 57,
	"./hr": 58,
	"./hr.js": 58,
	"./hu": 59,
	"./hu.js": 59,
	"./hy-am": 60,
	"./hy-am.js": 60,
	"./id": 61,
	"./id.js": 61,
	"./is": 62,
	"./is.js": 62,
	"./it": 64,
	"./it-ch": 63,
	"./it-ch.js": 63,
	"./it.js": 64,
	"./ja": 65,
	"./ja.js": 65,
	"./jv": 66,
	"./jv.js": 66,
	"./ka": 67,
	"./ka.js": 67,
	"./kk": 68,
	"./kk.js": 68,
	"./km": 69,
	"./km.js": 69,
	"./kn": 70,
	"./kn.js": 70,
	"./ko": 71,
	"./ko.js": 71,
	"./ku": 72,
	"./ku.js": 72,
	"./ky": 73,
	"./ky.js": 73,
	"./lb": 74,
	"./lb.js": 74,
	"./lo": 75,
	"./lo.js": 75,
	"./lt": 76,
	"./lt.js": 76,
	"./lv": 77,
	"./lv.js": 77,
	"./me": 78,
	"./me.js": 78,
	"./mi": 79,
	"./mi.js": 79,
	"./mk": 80,
	"./mk.js": 80,
	"./ml": 81,
	"./ml.js": 81,
	"./mn": 82,
	"./mn.js": 82,
	"./mr": 83,
	"./mr.js": 83,
	"./ms": 85,
	"./ms-my": 84,
	"./ms-my.js": 84,
	"./ms.js": 85,
	"./mt": 86,
	"./mt.js": 86,
	"./my": 87,
	"./my.js": 87,
	"./nb": 88,
	"./nb.js": 88,
	"./ne": 89,
	"./ne.js": 89,
	"./nl": 91,
	"./nl-be": 90,
	"./nl-be.js": 90,
	"./nl.js": 91,
	"./nn": 92,
	"./nn.js": 92,
	"./pa-in": 93,
	"./pa-in.js": 93,
	"./pl": 94,
	"./pl.js": 94,
	"./pt": 96,
	"./pt-br": 95,
	"./pt-br.js": 95,
	"./pt.js": 96,
	"./ro": 97,
	"./ro.js": 97,
	"./ru": 98,
	"./ru.js": 98,
	"./sd": 99,
	"./sd.js": 99,
	"./se": 100,
	"./se.js": 100,
	"./si": 101,
	"./si.js": 101,
	"./sk": 102,
	"./sk.js": 102,
	"./sl": 103,
	"./sl.js": 103,
	"./sq": 104,
	"./sq.js": 104,
	"./sr": 106,
	"./sr-cyrl": 105,
	"./sr-cyrl.js": 105,
	"./sr.js": 106,
	"./ss": 107,
	"./ss.js": 107,
	"./sv": 108,
	"./sv.js": 108,
	"./sw": 109,
	"./sw.js": 109,
	"./ta": 110,
	"./ta.js": 110,
	"./te": 111,
	"./te.js": 111,
	"./tet": 112,
	"./tet.js": 112,
	"./tg": 113,
	"./tg.js": 113,
	"./th": 114,
	"./th.js": 114,
	"./tl-ph": 115,
	"./tl-ph.js": 115,
	"./tlh": 116,
	"./tlh.js": 116,
	"./tr": 117,
	"./tr.js": 117,
	"./tzl": 118,
	"./tzl.js": 118,
	"./tzm": 120,
	"./tzm-latn": 119,
	"./tzm-latn.js": 119,
	"./tzm.js": 120,
	"./ug-cn": 121,
	"./ug-cn.js": 121,
	"./uk": 122,
	"./uk.js": 122,
	"./ur": 123,
	"./ur.js": 123,
	"./uz": 125,
	"./uz-latn": 124,
	"./uz-latn.js": 124,
	"./uz.js": 125,
	"./vi": 126,
	"./vi.js": 126,
	"./x-pseudo": 127,
	"./x-pseudo.js": 127,
	"./yo": 128,
	"./yo.js": 128,
	"./zh-cn": 129,
	"./zh-cn.js": 129,
	"./zh-hk": 130,
	"./zh-hk.js": 130,
	"./zh-tw": 131,
	"./zh-tw.js": 131
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wap-banner.8d0d0e2.jpg";

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(146)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(142)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(154),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(144)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(145)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 154:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-news-item"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "display": "block"
    },
    attrs: {
      "href": '/post/' + _vm.news.uid + '.html',
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('div', {
    staticClass: "main-title"
  }, [_vm._v(" " + _vm._s(_vm.news.title.length > 30 ? _vm.news.title.substring(0, 30) + '...' : _vm.news.title) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info"
  }, [(false) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v(" " + _vm._s(_vm.news.article_type) + " ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "auther-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.news.author.name))]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeAgo(_vm.news.time)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.news.photo
    }
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('news')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-news",
    attrs: {
      "id": "pc-news"
    }
  }, [_c('div', {
    staticClass: "header-wrap",
    attrs: {
      "id": "header-wrap-id"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNav),
      expression: "showNav"
    }],
    staticClass: "nav"
  }, [_c('ul', [_c('img', {
    staticClass: "menu-logo",
    attrs: {
      "src": "https://www.xfz.cn/explore/xfz2019/static/img/logo.128ba78.png"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-summary"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-guest"
    }
  }, [_vm._v("邀请嘉宾")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-agenda"
    }
  }, [_vm._v("大会议程")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-award"
    }
  }, [_vm._v("奖项评选")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-tickets"
    }
  }, [_vm._v("参会购票")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-partners"
    }
  }, [_vm._v("合作机构")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-contact-us"
    }
  }, [_vm._v("联系我们")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "section live"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "live-wrap"
  }, [_c('div', {
    staticClass: "live-title"
  }, [_vm._v("直播支持平台")]), _vm._v(" "), _c('div', {
    staticClass: "live-items-wrap"
  }, [_c('div', {
    staticClass: "live-area"
  }, _vm._l((_vm.liveLinks), function(item) {
    return _c('a', {
      staticClass: "live-item",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })])
  }))])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section live"
  }, [_c('div', {
    staticClass: "live-wrap"
  }, [_c('div', {
    staticClass: "live-title"
  }, [_vm._v("大会直播")]), _vm._v(" "), _c('div', {
    staticClass: "live-items-wrap"
  }, [_c('div', {
    staticClass: "live-area"
  }, _vm._l((_vm.liveData[0]), function(item) {
    return _c('div', {
      staticClass: "live-item"
    }, [_c('div', {
      staticClass: "live-name"
    }, [_c('a', {
      attrs: {
        "href": item.links[0].link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "live-links"
    }, [(item.links.length == 1) ? [_c('div', {
      staticClass: "link-item"
    }, [_c('a', {
      attrs: {
        "href": item.links[0].link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.links[0].name))])])] : _vm._e(), _vm._v(" "), (item.links.length == 2) ? [_c('div', {
      staticClass: "link-item"
    }, [_c('a', {
      attrs: {
        "href": item.links[0].link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.links[0].name))])]), _vm._v(" "), _c('div', {
      staticClass: "link-divider"
    }, [_vm._v("  ")]), _vm._v(" "), _c('div', {
      staticClass: "link-item"
    }, [_c('a', {
      attrs: {
        "href": item.links[1].link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.links[1].name))])])] : _vm._e()], 2)])
  }))])])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section course"
  }, [_c('div', {
    staticClass: "course-wrap"
  }, [_c('div', {
    staticClass: "course-title"
  }, [_vm._v("投资人眼中的消费升级")]), _vm._v(" "), _c('div', {
    staticClass: "course-items-wrap"
  }, [_c('div', {
    staticClass: "course-area"
  }, _vm._l((_vm.investorUpData), function(item) {
    return _c('div', {
      staticClass: "course-item"
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "info-logo"
    }, [_c('img', {
      staticClass: "main",
      attrs: {
        "src": item.img,
        "alt": "资本寒冬，创业公司如何快速获取融资"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tags"
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-content"
    }, [_c('div', {
      staticClass: "course-item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "info-author"
    }, [_vm._v(_vm._s(item.name) + " " + _vm._s(item.position ? '/' : '') + " " + _vm._s(item.position))])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "course-wrap"
  }, [_c('div', {
    staticClass: "course-title"
  }, [_vm._v("新品牌、新零售、新场景")]), _vm._v(" "), _c('div', {
    staticClass: "course-items-wrap"
  }, [_c('div', {
    staticClass: "course-area"
  }, _vm._l((_vm.useUpData), function(item) {
    return _c('div', {
      staticClass: "course-item"
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "info-logo"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": "资本寒冬，创业公司如何快速获取融资"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tags"
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-content"
    }, [_c('div', {
      staticClass: "course-item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "info-author"
    }, [_vm._v(_vm._s(item.name) + " " + _vm._s(item.position ? '/' : '') + " " + _vm._s(item.position))])])])])
  }))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pc-news-list"
  }, [_c('div', {
    staticClass: "news-list-wrap"
  }, [_c('div', {
    staticClass: "title-area"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("大会相关新闻")]), _vm._v(" "), _c('div', {
    staticClass: "refresh",
    on: {
      "click": function($event) {
        _vm.refreshContent()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(132),
      "alt": ""
    }
  }), _vm._v(" 刷新\n                ")])]), _vm._v(" "), _vm._l((_vm.newsData), function(item) {
    return [_c('pc-news-item', {
      attrs: {
        "news": item
      }
    })]
  }), _vm._v(" "), (_vm.newsData.length == 0) ? [_c('div', {
    staticStyle: {
      "width": "200px",
      "text-align": "center",
      "margin": "20px auto",
      "font-size": "22px"
    }
  }, [_vm._v("暂无新闻")])] : _vm._e()], 2)]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-wrap"
  }, [_c('div', {
    staticClass: "live-title"
  }, [_vm._v("官方直播平台")]), _vm._v(" "), _c('div', {
    staticClass: "live-items-wrap"
  }, [_c('div', {
    staticClass: "live-area"
  }, [_c('a', {
    staticClass: "live-item",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "href": "https://m.yiketalks.com/html/liveEnrollDetail2.html?id=1241",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://static-image.xfz.cn/1573721713130/一刻-fintech.partner"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "live-item",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "href": "https://live.photoplus.cn/live/54564923",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://static-image.xfz.cn/1573726183073/谱时-fintech.partner"
    }
  })])])])])
}]}

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-news-item"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": '/post/' + _vm.news.uid + '.html',
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "left-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.news.photo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "main-title"
  }, [_vm._v("\n            " + _vm._s(_vm.news.title.length > 50 ? _vm.news.title.substring(0, 48) + '...' : _vm.news.title) + "\n\n\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("\n            " + _vm._s(_vm.news.intro.length > 160 ? _vm.news.intro.substring(0, 160) + '...' : _vm.news.intro) + "\n\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info"
  }, [_c('div', {
    staticClass: "tag"
  }), _vm._v(" "), _c('div', {
    staticClass: "auther-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                    " + _vm._s(_vm.news.author.name) + " \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v("\n                    " + _vm._s(_vm.timeAgo(_vm.news.time)) + "\n                ")])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPc()) ? _c('pc-news') : _c('mobile-news')
},staticRenderFns: []}

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-news",
    attrs: {
      "id": "mobile-news"
    }
  }, [_c('div', {
    staticClass: "banner",
    attrs: {
      "id": "section-banner"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('ul', [_c('img', {
    staticClass: "menu-logo",
    attrs: {
      "src": "https://www.xfz.cn/explore/xfz2019/static/img/logo.128ba78.png"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-summary"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-guest"
    }
  }, [_vm._v("邀请嘉宾")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-agenda"
    }
  }, [_vm._v("大会议程")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-award"
    }
  }, [_vm._v("奖项评选")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-tickets"
    }
  }, [_vm._v("参会购票")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-partners"
    }
  }, [_vm._v("合作机构")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "/explore/xfz2019/#s-contact-us"
    }
  }, [_vm._v("联系我们")])])])])]), _vm._v(" "), _c('img', {
    staticClass: "banner-img",
    attrs: {
      "src": __webpack_require__(148)
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "section live"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "live-wrap"
  }, [_c('div', {
    staticClass: "live-title"
  }, [_vm._v("直播支持平台")]), _vm._v(" "), _c('div', {
    staticClass: "live-items-wrap"
  }, [_c('div', {
    staticClass: "live-area"
  }, _vm._l((_vm.liveLinks), function(item) {
    return _c('a', {
      staticClass: "live-item",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })])
  }))])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section live"
  }, [_c('a', {
    attrs: {
      "name": "s-live",
      "id": "s-live"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "live-area"
  }, [_c('div', {
    staticClass: "news-title"
  }, [_vm._v("大会直播")]), _vm._v(" "), _vm._l((_vm.liveData[0]), function(item) {
    return _c('div', {
      staticClass: "live-item"
    }, [_c('div', {
      staticClass: "live-name"
    }, [_c('a', {
      attrs: {
        "href": item.links[0].link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "live-links"
    }, [(item.links.length == 1) ? [_c('div', {
      staticClass: "link-item"
    }, [_c('a', {
      attrs: {
        "href": item.links[0].link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.links[0].name))])])] : _vm._e(), _vm._v(" "), (item.links.length == 2) ? [_c('div', {
      staticClass: "link-item"
    }, [_c('a', {
      attrs: {
        "href": item.links[0].link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.links[0].name))])]), _vm._v(" "), _c('div', {
      staticClass: "link-divider"
    }, [_vm._v("  ")]), _vm._v(" "), _c('div', {
      staticClass: "link-item"
    }, [_c('a', {
      attrs: {
        "href": item.links[1].link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.links[1].name))])])] : _vm._e()], 2)])
  })], 2)])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section course"
  }, [_c('div', {
    staticClass: "course-wrap"
  }, [_c('div', {
    staticClass: "course-title"
  }, [_vm._v("投资人眼中的消费升级")]), _vm._v(" "), _c('div', {
    staticClass: "course-items-wrap"
  }, [_c('div', {
    staticClass: "course-area"
  }, _vm._l((_vm.investorUpData), function(item) {
    return _c('div', {
      staticClass: "course-item"
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "info-logo"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": "资本寒冬，创业公司如何快速获取融资"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tags"
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-content"
    }, [_c('div', {
      staticClass: "info-author"
    }, [_vm._v(_vm._s(item.name) + " " + _vm._s(item.position ? '/' : '') + " " + _vm._s(item.position))])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "course-wrap"
  }, [_c('div', {
    staticClass: "course-title"
  }, [_vm._v("新品牌、新零售、新场景")]), _vm._v(" "), _c('div', {
    staticClass: "course-items-wrap"
  }, [_c('div', {
    staticClass: "course-area"
  }, _vm._l((_vm.useUpData), function(item) {
    return _c('div', {
      staticClass: "course-item"
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "info-logo"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": "资本寒冬，创业公司如何快速获取融资"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tags"
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-content"
    }, [_c('div', {
      staticClass: "info-author"
    }, [_vm._v(_vm._s(item.name) + " " + _vm._s(item.position ? '/' : '') + " " + _vm._s(item.position))])])])])
  }))])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "mobile-news-list"
  }, [_c('div', {
    staticClass: "title-area"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("大会相关新闻")]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "refresh",
    on: {
      "click": function($event) {
        _vm.refreshContent()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "refresh-content"
  }, [_vm._v("刷新")])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.newsData), function(item) {
    return [_c('mobile-news-item', {
      attrs: {
        "news": item
      }
    })]
  }), _vm._v(" "), (_vm.newsData.length == 0) ? [_c('div', {
    staticStyle: {
      "width": "200px",
      "text-align": "center",
      "margin": "20px auto",
      "font-size": "18px"
    }
  }, [_vm._v("暂无新闻")]), _vm._v(" "), _c('br')] : _vm._e()], 2), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-wrap"
  }, [_c('div', {
    staticClass: "live-title"
  }, [_vm._v("官方直播平台")]), _vm._v(" "), _c('div', {
    staticClass: "live-items-wrap"
  }, [_c('div', {
    staticClass: "live-area",
    staticStyle: {
      "text-align": "left",
      "margin-left": "20px"
    }
  }, [_c('a', {
    staticClass: "live-item",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "href": "https://m.yiketalks.com/html/liveEnrollDetail2.html?id=1241",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://static-image.xfz.cn/1573721713130/一刻-fintech.partner"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "live-item",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "href": "https://live.photoplus.cn/live/54564923",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://static-image.xfz.cn/1573726183073/谱时-fintech.partner"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "refresh-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(132)
    }
  })])
}]}

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var liveData = [[{
    title: '主论坛',
    links: [{
        name: '微吼直播',
        link: ' http://e.vhall.com/701353725'
    }, {
        name: '三千氪',
        link: 'https://3qk.easyvaas.com/show/play/index?vid=BzA0MS5bRD6lh2p5'
    }]
}, {
    title: '品类爆发与品质崛起',
    links: [{
        name: '微吼直播',
        link: 'http://e.vhall.com/733945677'
    }]
}, {
    title: '人群迭代与场景创新',
    links: [{
        name: '三千氪',
        link: 'https://3qk.easyvaas.com/show/play/index?vid=PeYKdIOR0Xylumr0'
    }]
}, {
    title: '现场精彩图片',
    links: [{
        name: '谱时',
        link: 'http://t.cn/RCvhdFr'
    }]
}], [{
    title: '主论坛',
    links: [{
        name: '微吼直播',
        link: 'http://e.vhall.com/580230662'
    }, {
        name: '视友直播',
        link: 'http://blive.cuctv.com/nl/1f5lDRu8fMc.html'
    }]
}, {
    title: '保险行业论坛',
    links: [{
        name: '微吼直播',
        link: 'http://e.vhall.com/378818341'
    }, {
        name: '视友直播',
        link: 'http://blive.cuctv.com/nl/1f5lDRu8fMc.html'
    }]
}, {
    title: '金融行业企业服务',
    links: [{
        name: '微吼直播',
        link: 'http://e.vhall.com/368405011'
    }]
}, {
    title: '人工智能论坛',
    links: [{
        name: '微吼直播',
        link: 'http://e.vhall.com/580230662'
    }]
}]];

/* harmony default export */ __webpack_exports__["a"] = (liveData);

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);


var util = {
    resource: function resource(options) {
        if (!options.data) {
            options.data = {};
        }
        if (!options.method) {
            options.method = 'get';
        }
        if (options.method == 'get') {
            options.data = {
                params: options.data
            };
        }
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http[options.method](options.url, options.data).then(function (res) {
            return res.json();
        }).then(function (res) {
            options.success(res);
        });
    },

    getWx: function getWx() {
        var _this = this;
        var data = {
            url: location.href,
            csrfmiddlewaretoken: $('.login-container input').val()
        };
        $.ajax({
            url: '/api/website/signature/weixin/',
            type: 'post',
            data: data,
            success: function success(res) {
                _this.callBack(res.data);
            }
        });
    },

    callBack: function callBack(data) {
        var wxurl = location.href;
        var wxtitle = "[正在直播]2019小饭桌全球青年创业者大会！TRUST 相信，相信的力量！";
        var wxdes = "大会正在直播，精彩不容错过";
        var wximg = "https://static-miniapp.xfz.cn/xiaofanzhuologo.jpg";

        wx.config({
            debug: false,
            appId: data.app_id,
            timestamp: data.timestamp,
            nonceStr: data.noncestr,
            signature: data.signature,
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
        });
        wx.ready(function () {
            wx.onMenuShareTimeline({
                title: wxtitle,
                link: wxurl,
                imgUrl: wximg,
                desc: wxdes,
                success: function success() {},
                cancel: function cancel() {}
            });
            wx.onMenuShareAppMessage({
                title: wxtitle,
                link: wxurl,
                imgUrl: wximg,
                desc: wxdes,
                type: '',
                dataUrl: '',
                success: function success() {},
                cancel: function cancel() {}
            });
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ })

},[141]);


// WEBPACK FOOTER //
// static/js/app.8b571bb7124ed91bb23a.js